export default "__VITE_ASSET__P6W4Nijl__"